import FormButtons from "components/FormButtons"
import React, { ChangeEvent } from "react"
import { useTranslation } from "react-i18next"
import { IntegrationType, UserData } from "types"
import { Box, SingleSelect, SingleSelectOption, TextInput } from "@strapi/design-system"

const groups = ["Admin", "Merchant", "Editor"]

interface UserFormProps {
  handleSave: () => void
  userData: UserData
  onChange: (userData: UserData) => void
  loading: boolean
  add?: boolean
  cancelLink?: string
  showGroups?: boolean
  showMerchantId?: boolean
}

export const UserForm = ({
  handleSave,
  userData,
  onChange,
  loading,
  add,
  cancelLink,
  showGroups = false,
  showMerchantId = true,
}: UserFormProps) => {
  const isValidUserData = () => {
    const hasValidUsername = userData.username?.length > 1
    const hasValidPassword = userData.password?.length > 1
    const hasGroup = userData.group
    const hasValidGroup = hasGroup ? userData.group?.length > 1 : true

    return hasValidUsername && hasValidPassword && hasValidGroup
  }

  const { t } = useTranslation()
  const saveDisabled = !isValidUserData()
  return (
    <Box>
      <Box style={{ paddingBottom: "18px" }}>
        <TextInput
          required
          label={t("username")}
          name="username"
          disabled={!add}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            onChange({
              ...userData,
              username: e.target.value,
            })
          }
          value={userData.username}
        />
      </Box>

      {showMerchantId ? (
        <Box style={{ paddingBottom: "18px" }}>
          <TextInput
            disabled={true}
            label={t("merchantId")}
            name="merchantId"
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChange({
                ...userData,
                merchantId: e.target.value,
              })
            }}
            value={userData.merchantId}
          />
        </Box>
      ) : null}

      {userData.integrationType === IntegrationType.COMMON ? (
        <Box style={{ paddingBottom: "18px" }}>
          <TextInput
            required
            className="key"
            label={add ? t("password") : t("newPassword")}
            name="new-password"
            type="text"
            aria-autocomplete="new-password"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              onChange({
                ...userData,
                password: e.target.value,
              })
            }
            value={userData.password}
          />
        </Box>
      ) : null}

      {showGroups ? (
        <Box style={{ paddingBottom: "18px" }}>
          <SingleSelect
            label={t("group")}
            required
            disabled={!add}
            onChange={(value: string) =>
              onChange({
                ...userData,
                group: value,
              })
            }
            value={userData.group}
          >
            {groups.map((group) => (
              <SingleSelectOption value={group} key={group}>
                {group}
              </SingleSelectOption>
            ))}
          </SingleSelect>
        </Box>
      ) : null}
      <FormButtons
        saveDisabled={saveDisabled}
        loading={loading}
        onSave={handleSave}
        cancelLink={cancelLink || `/users`}
      />
    </Box>
  )
}
